/**
 * @file
 * Add functionality of expanded text on click.
 *
 * @see https://github.com/kswedberg/jquery-expander
 */

const $expand = $('.text-expand', context);

$expand.once('text-expanded').each((index, el) => {
  const $this = $(el);
  const options = {
    slicePoint: 800,
    preserveWords: true,
    expandText: 'Read more »',
    expandPrefix: '',
    userCollapse: false,
    moreClass: 'text-expand--expanded',
    summaryClass: 'text-expand--summary',
    detailClass: 'text-expand--details',
    expandEffect: 'slideDown',
    expandSpeed: 0,
    widow: 4,
  };

  $this.expander(options);
});
